import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Form,
  Label,
  LabelInput,
} from '../../common/components/form';
import { StyledStaticField } from '../../common/components/form/ui';
import Button from '../../../ui/button/Button';

import { Localize } from '../../../locale/localization';

const EditProfileForm = (props) => {
  const {
    enabled,
    onSubmit,
    onBlur,
    onInputChange,
    errors,
    touchedFields,
    isValid,
    firstName,
    lastName,
    address,
    zipcode,
    city,
    email, //readonly
    team, //readonly
  } = props;

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      {team && (
        <Label label="Tiimi">
          <StyledStaticField>{team}</StyledStaticField>
        </Label>
      )}
      <LabelInput
        half
        type="text"
        label="Etunimi"
        name="firstName"
        value={firstName}
        error={errors['firstName'] && touchedFields.indexOf('firstName') > -1}
        errorMessage={errors['firstName']}
        onChange={onInputChange}
      />
      <LabelInput
        half
        type="text"
        label="Sukunimi"
        name="lastName"
        value={lastName}
        error={errors['lastName'] && touchedFields.indexOf('lastName') > -1}
        errorMessage={errors['lastName']}
        onChange={onInputChange}
      />
      <LabelInput
        type="text"
        label="Katuosoite"
        name="address"
        value={address}
        error={errors['address'] && touchedFields.indexOf('address') > -1}
        errorMessage={errors['address']}
        onChange={onInputChange}
      />
      <LabelInput
        half
        type="text"
        label="Postinumero"
        name="zipcode"
        value={zipcode}
        error={errors['zipcode'] && touchedFields.indexOf('zipcode') > -1}
        errorMessage={errors['zipcode']}
        onChange={onInputChange}
      />
      <LabelInput
        half
        type="text"
        label="Postitoimipaikka"
        name="city"
        value={city}
        error={errors['city'] && touchedFields.indexOf('city') > -1}
        errorMessage={errors['city']}
        onChange={onInputChange}
      />
      <Label label={Localize('form.user.label')} half>
        <StyledStaticField>{email}</StyledStaticField>
      </Label>
      <LabelInput
        half
        disabled
        label={Localize('password')}
        name="password"
        type="password"
        value="*****"
      >
        <NavLink to="/profile/changePassword">{Localize('password.change')}</NavLink>
      </LabelInput>
      <footer>
        <Button disabled={!isValid || !enabled} type="submit">{Localize('action.save')}</Button>
      </footer>
    </Form>
  );
};

export default EditProfileForm;


// WEBPACK FOOTER //
// ./src/modules/user/components/EditProfileForm.js